import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/warehouse/stock/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/warehouse/stock/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/warehouse/stock/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/warehouse/stock/save', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/warehouse/stock/update', params,options);

export const selectStockSum = (params, options) =>
  request.get('/api/v4ward/warehouse/stock/selectStockSum', Object.assign({}, options, { params }));


